import { Row, Col } from "react-bootstrap";

import classes from "../../../purchase.module.scss";

const OrdersDeliveryActionSelect = () => {
	return (
		<Row className={classes.actions}>
			<Col className={classes.actionRow} md={12}>
				<div className={classes.label}>Seleccione una opción</div>
			</Col>

			<hr className={classes.separator} />
		</Row>
	);
};

export default OrdersDeliveryActionSelect;
